<ion-card>
  <ion-card-header>
    <ion-card-title>KRÉTA csoportbesorolás</ion-card-title>
    <ion-card-subtitle>
      Ugyanaz, mint a KRÉTÁ-ból letöltött Excelt betölteni a csoporttagság-importba – csak fájl nélkül.
      A szinkron <b>nem nyúl a névsorhoz</b>: letölti a KRÉTA besorolásait, és megmutatja, mi lenne belőle.
      Írni csak az <b>Átvétel</b> ír, a jóváhagyásod után.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <p *ngIf="hiba" class="kcs-hiba">{{ hiba }}</p>

    <!-- ── 1. SZINKRON ─────────────────────────────────────────────────── -->
    <div class="kcs-blokk">
      <h4>1. Letöltés a KRÉTÁ-ból</h4>
      <div class="kcs-sor">
        <ion-select label="KRÉTA-fiók" label-placement="stacked" interface="popover" style="min-width:220px"
                    [(ngModel)]="fiok">
          <ion-select-option *ngFor="let f of allapot?.fiokok" [value]="f.allomany">
            {{ f.allomany }} ({{ f.kreta_user }})
          </ion-select-option>
        </ion-select>
        <ion-button size="small" (click)="szinkron()" [disabled]="fut || !fiok">
          <ion-icon slot="start" name="cloud-download-outline"></ion-icon>Szinkron indítása
        </ion-button>
        <ion-button size="small" fill="outline" (click)="allapotBetolt(); parositasBetolt()" [disabled]="toltodik">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>

      <div class="kcs-allapot" *ngIf="folyamat?.fut">
        <ion-spinner name="dots"></ion-spinner> {{ folyamat?.lepes || 'Fut…' }}
      </div>
      <div class="kcs-allapot hiba" *ngIf="folyamat && !folyamat.fut && folyamat.hiba">{{ folyamat.hiba }}</div>

      <div class="kcs-szamok" *ngIf="allapot?.szamok">
        <span><b>{{ allapot.szamok.csoport_db }}</b> KRÉTA-csoport</span>
        <span><b>{{ allapot.szamok.tagsag_db }}</b> besorolás</span>
        <span><b>{{ allapot.szamok.osztaly_db }}</b> osztály</span>
        <!--  Az azonosítatlan sor a legfontosabb szám: ahol van ilyen, ott nem zárunk le
              semmit, mert épp azt vennénk ki, akit nem ismerünk fel. -->
        <span [class.kcs-figyelem]="allapot.szamok.azonositatlan_db">
          <b>{{ allapot.szamok.azonositatlan_db }}</b> azonosítatlan tanuló
        </span>
      </div>
      <div class="kcs-halvany" *ngIf="allapot?.utolso_futas">
        Utolsó futás: {{ allapot.utolso_futas.kezdete | date:'yyyy. MM. dd. HH:mm' }}
        – {{ allapot.utolso_futas.allapot }}<span *ngIf="allapot.utolso_futas.fiok"> ({{ allapot.utolso_futas.fiok }})</span>
      </div>
      <div class="kcs-halvany" *ngIf="allapot?.vegpontok?.csoport_vegpont">
        Megtalált rács-végpont: <code>{{ allapot.vegpontok.csoport_vegpont }}</code>
      </div>
    </div>

    <!-- ── 2. PÁROSÍTÁS ────────────────────────────────────────────────── -->
    <div class="kcs-blokk" *ngIf="parok.length">
      <h4>2. Párosítás <span class="kcs-halvany">({{ parok.length }} KRÉTA-csoport, ebből {{ parositatlanDb }} párosítatlan)</span></h4>
      <p class="kcs-halvany">
        A névegyezés magától megvan („Napközi 1z" = „napközi 1.z"). Ami nem egyértelmű, azt
        itt mondd meg – amíg párosítatlan, az a csoport kimarad az átvételből.
      </p>
      <div class="kcs-tabla-burok">
        <table class="kcs-tabla">
          <thead><tr>
            <th>KRÉTA-csoport</th><th>Típus</th><th class="num">Tagok</th>
            <th>SULINFORM-csoport</th><th></th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let p of parok" [class.kcs-parositatlan]="!p.cel">
              <td>{{ p.nev }}</td>
              <td class="kcs-halvany">{{ p.tipus || '–' }}</td>
              <td class="num">
                {{ p.tag_db }}
                <span class="kcs-figyelem" *ngIf="p.azonositatlan_db"> ({{ p.azonositatlan_db }} ismeretlen)</span>
              </td>
              <td>
                <ion-select interface="alert" [interfaceOptions]="{ cssClass: 'nagy' }" placeholder="– nincs párosítva –"
                            [(ngModel)]="p.cel">
                  <ion-select-option [value]="null">– nincs párosítva –</ion-select-option>
                  <ion-select-option *ngFor="let c of sajatCsoportok" [value]="c.id">
                    {{ c.nev }}<span *ngIf="c.ev"> ({{ c.ev }})</span>
                  </ion-select-option>
                </ion-select>
                <div class="kcs-halvany" *ngIf="p.forras === 'nev'">névegyezésből</div>
              </td>
              <td>
                <ion-button size="small" fill="clear" (click)="parositasMent(p)">Mentés</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ── 3. ÁTVÉTEL ──────────────────────────────────────────────────── -->
    <div class="kcs-blokk" *ngIf="parok.length">
      <h4>3. Átvétel</h4>
      <div class="kcs-sor">
        <!--  A LEZÁRÁS KÜLÖN DÖNTÉS: névsort vesz el. A tagság nem törlődik, csak véget
              ér – a múltbeli névsor és a hozzá tartozó jegyek, hiányzások megmaradnak. -->
        <ion-toggle [(ngModel)]="lezaras" labelPlacement="end">
          Aki a KRÉTÁ-ban már nincs a csoportban, annak a tagságát lezárom
        </ion-toggle>
        <ion-button size="small" fill="outline" (click)="elonezet()" [disabled]="toltodik">
          <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
        </ion-button>
        <ion-button size="small" color="success" (click)="atvesz()" [disabled]="fut || !terv">
          <ion-icon slot="start" name="download-outline"></ion-icon>Átvétel
        </ion-button>
      </div>

      <div *ngIf="terv">
        <div class="kcs-szamok">
          <span><b>{{ terv.uj_osszesen }}</b> új tagság</span>
          <span *ngIf="terv.lezaras"><b>{{ terv.lezarhato_osszesen }}</b> lezárható tagság</span>
          <span *ngIf="terv.letrehozando_osszesen"><b>{{ terv.letrehozando_osszesen }}</b> új csoport a KRÉTÁ-ból</span>
          <span class="kcs-halvany">érvényesség kezdete: {{ terv.nap }}</span>
        </div>
        <div class="kcs-tabla-burok">
          <table class="kcs-tabla">
            <thead><tr><th>Csoport</th><th class="num">Új</th><th class="num">Lezárható</th><th>Megjegyzés</th></tr></thead>
            <tbody>
              <tr *ngFor="let c of terv.csoportok">
                <td>{{ c.nev }}<span class="kcs-halvany" *ngIf="c.cel_nev"> → {{ c.cel_nev }}</span></td>
                <td class="num">{{ c.uj?.length || 0 }}</td>
                <td class="num">{{ c.lezarhato?.length || 0 }}</td>
                <td class="kcs-halvany">
                  <span *ngIf="c.allapot === 'parositatlan'">párosítatlan – kimarad</span>
                  <span *ngIf="c.allapot === 'letrehozando'">nálunk még nincs – az átvétel létrehozza (KRÉTA-név, osztály-kötés a névből)</span>
                  <span class="kcs-figyelem" *ngIf="c.lezaras_tiltva">{{ c.lezaras_tiltva }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ── OSZTÁLYBESOROLÁS: csak összehasonlítás ──────────────────────── -->
    <div class="kcs-blokk">
      <h4>Osztálybesorolás – eltérések</h4>
      <p class="kcs-halvany">
        Az osztályt <b>nem írjuk át</b> magunktól: nálunk jogviszony, tanévhez kötve, és a lezárt
        tanév adatához elvből nem nyúlunk. Ami itt látszik, az a kérdések listája.
      </p>
      <ion-button size="small" fill="outline" (click)="osztalyBetolt()" [disabled]="toltodik">
        <ion-icon slot="start" name="git-compare-outline"></ion-icon>Eltérések lekérése
      </ion-button>
      <div class="kcs-tabla-burok" *ngIf="osztalyElteres?.tetelek?.length">
        <table class="kcs-tabla">
          <thead><tr><th>KRÉTA-osztály</th><th>Csak a KRÉTÁ-ban</th><th>Csak nálunk</th></tr></thead>
          <tbody>
            <tr *ngFor="let o of osztalyElteres.tetelek">
              <td>{{ o.nev }}<span class="kcs-halvany" *ngIf="o.cel_nev"> → {{ o.cel_nev }}</span></td>
              <td class="kcs-halvany">{{ nevsor(o.csak_kretaban) || '–' }}</td>
              <td class="kcs-halvany">{{ nevsor(o.csak_nalunk) || '–' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ── VISSZAÍRÁS: a kézi tagság-módosítások a KRÉTÁ-ba ───────────────── -->
    <div class="kcs-blokk">
      <h4>Visszaírás a KRÉTÁ-ba</h4>
      <p class="kcs-halvany">
        Amit nálunk kézzel módosítottak (Adathiba jelzése, csoportbesorolás) és a KRÉTÁ-ban még a régi
        állapot van: a rendszer a KRÉTA saját <b>besorolás</b>, illetve <b>kiléptetés</b> lapján vezeti át,
        a nálunk érvényes dátummal. Ha a KRÉTÁ-ban közben már átvezették, nem küld semmit; ha a KRÉTÁ-ban
        a tanulónak saját kilépési dátuma van, azt nem írja felül. Kiléptetésnél a nálunk rögzített
        (a kilépés napjára szóló) záradék is bekerül.
      </p>
      <ion-item lines="none">
        <ion-checkbox [(ngModel)]="visszairasAuto" (ionChange)="visszairasAutoMent()" labelPlacement="end">
          Automatikus visszaírás (a napi KRÉTA-szinkron után magától lefut)
        </ion-checkbox>
      </ion-item>
      <div class="kcs-sor">
        <ion-button size="small" fill="outline" (click)="visszairasBetolt()" [disabled]="toltodik">
          <ion-icon slot="start" name="list-outline"></ion-icon>Átvezetendők
        </ion-button>
        <ion-button size="small" fill="outline" (click)="visszairasKuld(true)" [disabled]="vFut || !visszairas?.kuldheto">
          <ion-icon slot="start" name="eye-outline"></ion-icon>Száraz futás
        </ion-button>
        <ion-button size="small" (click)="visszairasKuld(false)" [disabled]="vFut || !visszairas?.kuldheto || !visszairas?.elesitve">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>{{ vFut ? 'Folyamatban…' : 'Küldés a KRÉTÁ-ba most' }}
        </ion-button>
      </div>
      <div *ngIf="visszairas">
        <div class="kcs-szamok"><span><b>{{ visszairas.osszesen }}</b> átvezetendő, ebből <b>{{ visszairas.kuldheto }}</b> küldhető</span></div>
        <div class="kcs-tabla-burok" *ngIf="visszairas.tetelek?.length">
          <table class="kcs-tabla">
            <thead><tr><th>Tanuló</th><th>Csoport</th><th>Teendő</th><th>Dátum</th><th>Állapot</th></tr></thead>
            <tbody>
              <tr *ngFor="let t of visszairas.tetelek">
                <td>{{ t.nev }}</td>
                <td>{{ t.csoport_nev || '—' }}</td>
                <td>{{ t.muvelet === 'besorolas' ? 'besorolás' : 'kiléptetés' }}</td>
                <td class="kcs-halvany">{{ t.datum || '—' }}</td>
                <td [class.kcs-halvany]="!t.kuldheto">
                  {{ t.kuldheto ? 'küldhető' : t.ok }}
                  <div *ngIf="t.elozo_hiba" class="kcs-hiba">Előző próbálkozás: {{ t.elozo_hiba }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="vEredmeny" class="kcs-halvany">
          {{ vEredmeny.szaraz ? 'Száraz futás – semmi nem ment ki.' : ('Elküldve: ' + vEredmeny.elkuldve + ', már rendben volt: ' + vEredmeny.mar_rendben + ', hiba: ' + vEredmeny.hiba + '.') }}
          <div *ngFor="let e of vEredmeny.tetelek">{{ e.nev }} · {{ e.csoport }} · {{ e.ok ? (e.mar ? 'a KRÉTÁ-ban már rendben' : (e.szaraz ? 'kitölthető' : 'elküldve')) : ('hiba: ' + e.szoveg) }}</div>
        </div>
      </div>
    </div>

    <!-- ── TANULÓI TÖRZSADATOK ─────────────────────────────────────────── -->
    <div class="kcs-blokk">
      <h4>Tanulói törzsadatok a KRÉTÁ-ból</h4>
      <p class="kcs-halvany">
        Naplósorszám, törzslapszám, beírási napló sorszáma, diákigazolvány száma, állandó és
        tartózkodási cím – <b>minden tanulóra</b>. A letöltés csak a KRÉTA-adatlapokat olvassa (a fent
        kiválasztott fiókkal); írni az <b>Átvétel</b> ír. Csak kitölt vagy felülír, ahol a KRÉTÁ-ban van
        érték – <b>üres KRÉTA-mező semmit nem töröl</b>. A naplósorszám és a törzslapszám a ma élő
        jogviszonyba kerül; új tanulót nem vesz fel. Minden átírt mező régi értékkel naplózva.
      </p>
      <div class="kcs-sor">
        <ion-button size="small" (click)="tdSzinkron()" [disabled]="tdFut || !fiok">
          <ion-icon slot="start" name="cloud-download-outline"></ion-icon>Letöltés
        </ion-button>
        <ion-button size="small" fill="outline" (click)="tdElonezet()" [disabled]="toltodik || !td?.tukor?.db">
          <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
        </ion-button>
        <ion-button size="small" fill="outline" (click)="tdMezokBetolt()" [disabled]="toltodik || !td?.tukor?.db">
          <ion-icon slot="start" name="list-outline"></ion-icon>Látott KRÉTA-mezők
        </ion-button>
        <ion-button size="small" fill="clear" (click)="tdValtozasokBetolt()">
          Legutóbbi átvétel naplója
        </ion-button>
      </div>
      <div class="kcs-allapot" *ngIf="tdFolyamat?.fut">
        <ion-spinner name="dots"></ion-spinner> {{ tdFolyamat?.lepes || 'Fut…' }}
      </div>
      <div class="kcs-allapot hiba" *ngIf="tdFolyamat && !tdFolyamat.fut && tdFolyamat.hiba">{{ tdFolyamat.hiba }}</div>
      <div class="kcs-halvany" *ngIf="td?.tukor?.db">
        Tükör: {{ td.tukor.db }} KRÉTA-tanuló, letöltve {{ td.tukor.letoltve | date:'yyyy. MM. dd. HH:mm' }}
      </div>
      <div class="kcs-halvany" *ngIf="tdUtolsoLetoltes?.reszletek?.fulek?.length">
        Használt adatlap-fülek: <code>{{ tdUtolsoLetoltes.reszletek.fulek.join(', ') }}</code>
        <span *ngIf="tdUtolsoLetoltes.reszletek.cim_vegpont"> · címrács: <code>{{ tdUtolsoLetoltes.reszletek.cim_vegpont }}</code></span>
        <span *ngIf="tdUtolsoLetoltes.reszletek.felderites?.feltetelezett" class="kcs-figyelem">
          · a fülneveket a lap nem árulta el, feltételezett nevekkel próbáltuk</span>
      </div>

      <div *ngIf="tdTerv">
        <div class="kcs-szamok">
          <span><b>{{ tdTerv.kreta_db }}</b> KRÉTA-tanuló</span>
          <span><b>{{ tdTerv.egyezo }}</b> nálunk is megvan</span>
          <span [class.kcs-figyelem]="tdTerv.nincs_nalunk?.length"><b>{{ tdTerv.nincs_nalunk?.length || 0 }}</b> nincs nálunk</span>
          <span *ngIf="tdTerv.uj_tanulok?.length"><b>{{ tdTerv.uj_tanulok.length }}</b> új tanulóként felvehető</span>
          <span [class.kcs-figyelem]="tdTerv.jogviszony_nelkul?.length"><b>{{ tdTerv.jogviszony_nelkul?.length || 0 }}</b> élő jogviszony nélkül</span>
          <span><b>{{ tdTerv.valtozasok?.length || 0 }}</b> változó mező</span>
        </div>
        <div class="kcs-halvany">
          A KRÉTÁ-ban kitöltve:
          <span *ngFor="let k of tdTerv.statisztika | keyvalue">{{ k.key }}: {{ k.value }} · </span>
        </div>
        <div class="kcs-szamok" *ngIf="tdOsszesito.length">
          <span *ngFor="let o of tdOsszesito">{{ o.nev }}: <b>{{ o.db }}</b></span>
        </div>
        <div class="kcs-sor" *ngIf="tdTerv.valtozasok?.length || tdTerv.uj_tanulok?.length">
          <ion-button size="small" color="success" (click)="tdAtvesz()" [disabled]="tdFut">
            <ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Átvétel
            (<ng-container *ngIf="tdTerv.uj_tanulok?.length">{{ tdTerv.uj_tanulok.length }} új tanuló, </ng-container>{{ tdTerv.valtozasok?.length || 0 }} mező)
          </ion-button>
        </div>
        <!-- ÚJ TANULÓ A KRÉTÁ-BÓL: a KRÉTÁ-ban osztályba sorolt, nálunk nem szereplő diák tanulóként és
             jogviszonnyal (a párosított osztályba) kerül be; a csoportjait a tagság-szinkron hozza. -->
        <details *ngIf="tdTerv.uj_tanulok?.length" open>
          <summary>Új tanulóként felvesszük ({{ tdTerv.uj_tanulok.length }})</summary>
          <div class="kcs-figyelem" *ngIf="tdTerv.uj_tanulok.length > tdTerv.uj_tanulo_max">
            Egyszerre legfeljebb {{ tdTerv.uj_tanulo_max }} tanuló vehető fel így – ennyinél a KIR-importot használd.
          </div>
          <div class="kcs-halvany">
            <span *ngFor="let u of tdTerv.uj_tanulok; let i = index">{{ i ? ', ' : '' }}{{ u.nev }} ({{ u.osztaly }}, {{ u.kezdete }}-tól)</span>
          </div>
          <div class="kcs-halvany">A gondviselőket a KRÉTA tanulói adatlapja nem tartalmazza: őket a gondviselő-import hozza.</div>
        </details>
        <details *ngIf="tdTerv.uj_tanulo_kimarad?.length">
          <summary>A KRÉTÁ-ban van, de nem vehető fel automatikusan ({{ tdTerv.uj_tanulo_kimarad.length }})</summary>
          <div class="kcs-halvany" *ngFor="let k of tdTerv.uj_tanulo_kimarad">{{ k.nev }} ({{ k.osztaly || '–' }}): {{ k.ok }}</div>
        </details>
        <details *ngIf="tdTerv.valtozasok?.length">
          <summary>A változások tételesen</summary>
          <div class="kcs-tabla-burok">
            <table class="kcs-tabla">
              <thead><tr><th>Tanuló</th><th>Osztály</th><th>Mező</th><th>Most</th><th>KRÉTA</th></tr></thead>
              <tbody>
                <tr *ngFor="let v of tdTerv.valtozasok">
                  <td>{{ v.nev }}</td><td>{{ v.osztaly }}</td><td>{{ v.mezo_nev }}</td>
                  <td class="kcs-halvany">{{ v.regi || '–' }}</td><td>{{ v.uj }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </details>
        <details *ngIf="tdTerv.nincs_nalunk?.length">
          <summary>A KRÉTÁ-ban van, nálunk nincs ({{ tdTerv.nincs_nalunk.length }})</summary>
          <div class="kcs-halvany">{{ nevsor(mapNev(tdTerv.nincs_nalunk)) }}</div>
        </details>
        <details *ngIf="tdTerv.jogviszony_nelkul?.length">
          <summary>Nincs élő jogviszonya – a naplósorszám/törzslapszám kimarad ({{ tdTerv.jogviszony_nelkul.length }})</summary>
          <div class="kcs-halvany">{{ nevsor(mapNev(tdTerv.jogviszony_nelkul)) }}</div>
        </details>
      </div>

      <details *ngIf="tdMezok" open>
        <summary>Látott KRÉTA-mezők ({{ tdMezok.mezok?.length || 0 }}) – ellenőrizd, jó helyre mentek-e</summary>
        <div class="kcs-tabla-burok">
          <table class="kcs-tabla">
            <thead><tr><th>Forrás</th><th>Kulcs</th><th>Felirat</th><th>Nálunk</th><th>Kitöltve</th><th>Minta</th></tr></thead>
            <tbody>
              <tr *ngFor="let m of tdMezok.mezok">
                <td class="kcs-halvany">{{ m.forras }}</td><td><code>{{ m.kulcs }}</code></td><td>{{ m.cimke }}</td>
                <td [class.kcs-figyelem]="m.cel">{{ m.cel || '–' }}</td><td>{{ m.kitoltve }}</td>
                <td class="kcs-halvany">{{ m.minta }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </details>

      <details *ngIf="tdValtozasok">
        <summary>Legutóbbi átvétel: {{ tdValtozasok.tetelek?.length || 0 }} átírt mező</summary>
        <div class="kcs-tabla-burok" *ngIf="tdValtozasok.tetelek?.length">
          <table class="kcs-tabla">
            <thead><tr><th>Tanuló</th><th>Mező</th><th>Régi</th><th>Új</th><th>Mikor</th></tr></thead>
            <tbody>
              <tr *ngFor="let v of tdValtozasok.tetelek">
                <td>{{ v.nev || v.oktazon }}</td><td>{{ v.mezo_nev }}</td>
                <td class="kcs-halvany">{{ v.regi || '–' }}</td><td>{{ v.uj }}</td>
                <td class="kcs-halvany">{{ v.idopont | date:'yyyy. MM. dd. HH:mm' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </details>
    </div>
  </ion-card-content>
</ion-card>
